import type { FC, PropsWithChildren } from 'react';

import { Trans } from 'react-i18next';

import { ReactComponent as SliderIcon } from '../../assets/slider.svg';
import { ReactComponent as SplitScreenIcon } from '../../assets/split-screen.svg';
import { EViewMode } from '../../constants';

const optionClassName =
  '[font-family:"Nunito_Sans"] text-[rgba(0,_0,_0,_0.87)] leading-[18px] text-lg font-bold !rounded-[10px] h-10 px-3 max-sm:flex-1 max-sm:w-full max-sm:p-0';

const Option: FC<PropsWithChildren> = ({ children }) => (
  <span className='flex items-center gap-x-1.5 py-2.5 h-10 max-sm:justify-center'>{children}</span>
);

export const VIEW_MODE_OPTIONS = [
  {
    value: EViewMode.SPLIT_SCREEN,
    label: (
      <Option>
        <SplitScreenIcon />
        <Trans i18nKey='popups.remove_watermark_popup.split_screen' />
      </Option>
    ),
    className: optionClassName
  },
  {
    value: EViewMode.SLIDER,
    label: (
      <Option>
        <SliderIcon />
        <Trans i18nKey='popups.remove_watermark_popup.slider' />
      </Option>
    ),
    className: optionClassName
  }
];
